import {Box} from '@mantine/core';
import {useDisclosure} from '@mantine/hooks';
import type React from 'react';
import {useState} from 'react';
import {useRecoilState} from 'recoil';
import {scoutPopupShowDateState} from '../../../../shared/components/FollowCompany/TypeB';
import {NoLoginAlertModal} from '../../../../shared/components/NoLoginAlertModal';
import {formatNumberAsKilo} from '../../../../shared/services/formatNumberAsKilo';
import {useHandleFollowCompany} from '../../usecase/useHandleFollowCompany';
import {ScoutPopup} from './Presenter/ScoutPopupModal';

type Props = {
  companyId: number;
  isFollowed: boolean;
  followCount: number;
};

export const FollowCompanyButton: React.FC<Props> = ({
  followCount,
  isFollowed,
  companyId,
}) => {
  const [checked, setChecked] = useState(false);
  const [scoutPopup, setScoutPopup] = useState(false);

  const [scoutPopupShowDate, setScoutPopupShowDate] = useRecoilState(
    scoutPopupShowDateState,
  );

  const closePopup = () => {
    if (checked) {
      const now = new Date();
      setScoutPopupShowDate(now.toString());
    }

    setScoutPopup(false);
  };

  const [isLoginOpened, {open, close}] = useDisclosure(false);
  const {
    handleFollowCompany,
    followCountUpdated,
    isFollowed: isFollowUpdated,
  } = useHandleFollowCompany({
    companyId,
    followCount,
    followed: isFollowed,
    open,
    setScoutPopup,
    scoutPopupShowDate,
  });
  return (
    <>
      <Box
        className={`flex cursor-pointer px-8 items-center justify-center pc:hover:opacity-80 border-2 border-primary rounded-16 h-36 ${
          isFollowUpdated ? 'bg-primary text-white' : 'text-primary'
        }`}
        onClick={async (e) => {
          e.stopPropagation();
          try {
            await handleFollowCompany();
          } catch (error) {
            console.error(error);
          }
        }}
      >
        <span className="text-sm font-bold pb-[1px]">
          {isFollowUpdated ? 'フォロー中' : 'フォロー'}
        </span>
        <span className="text-sm mx-4 font-bold">
          {formatNumberAsKilo(followCountUpdated)}
        </span>
      </Box>
      <NoLoginAlertModal opened={isLoginOpened} onClose={close} />
      <ScoutPopup
        scoutPopup={scoutPopup}
        closePopup={closePopup}
        checked={checked}
        setChecked={setChecked}
      />
    </>
  );
};
